import './css/App.css';
import './css/Books.css';
import LazyImage from './components/LazyImage';
import { useMediaQuery } from 'react-responsive';

function BookCard({bookimage, booktitle, booksubtitle, bookdescription, booklinks, bookextra}){
    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });
    return (
        <div className={isMobile ? "book-card-mobile" : "book-card"}>
            <hr className="hr-break" />
            <LazyImage 
                className={isMobile ? "book-card-img-mobile" : "book-card-img"} 
                src={bookimage} 
                alt={`Cover of ${booktitle}`}
            />
            <div className="book-card-text">
            <h2 className="book-card-h2"><em>{booktitle}</em></h2>
            <h3>{booksubtitle}</h3>
            <p>{bookdescription}</p>
            {booklinks && (
                <div className="book-purchase-links">
                    {booklinks}
                </div>
            )}
            {bookextra ? <>{bookextra}</> : <></>}
            </div>
        </div>
    )
}

export default BookCard;
